module.exports = __webpack_public_path__ + "static/media/flipkart_color.70161cba.jpg";